// extracted by mini-css-extract-plugin
export default {"loadedApplicationContainer":"ApplicationsDashboardPage_loadedApplicationContainer__1dPrV","extraTools":"ApplicationsDashboardPage_extraTools__l3Dxw"};